import React, { PureComponent, Fragment} from 'react';
import Slider  from '~/core/scripts/components/Slider';
import Icon from '~/core/scripts/components/Icon'

class TimelineControls extends PureComponent {
  render() {
    const { minYear, maxYear } = this.props;

    return (
      <div className="timectrl">
        {/* <div>{minYear}</div> */}
        <div className="start">2000</div>
        <Slider
          min={+minYear}
          max={+maxYear}
          value={this.props.currentYear}
          onChange={this.props.onChangeYear}
          dots
        />
        {/* <div>{maxYear}</div> */}
        <div className="end">2018</div>
        <button
          className="btn"
          onClick={this.props.togglePlay}
        >
          {this.props.isPlaying ?  <Fragment><Icon type="pause" /> Pause</Fragment> : <Fragment><Icon type="play" /> Play</Fragment>}
        </button>
      </div>
    );
  }
}

export default TimelineControls;
